export const SECTION_IDS = {
    intro: 'intro',
    testimonials: 'testimonials',
    values: 'values',
    offices: 'offices',
    openPositions: 'open-positions',
    apply: 'apply',
} as const;

export type SectionId = (typeof SECTION_IDS)[keyof typeof SECTION_IDS];

/** Render order — drives scroll-spy trigger creation. Hero is intentionally absent (hash cleared at top). */
export const SECTION_ORDER: SectionId[] = [
    SECTION_IDS.intro,
    SECTION_IDS.testimonials,
    SECTION_IDS.values,
    SECTION_IDS.offices,
    SECTION_IDS.openPositions,
    SECTION_IDS.apply,
];

export const isSectionId = (value: string): value is SectionId => (SECTION_ORDER as string[]).includes(value);
